/**
 * menu handling (desktop & mobile)
 */
jQuery(($) => {
    // global search handling
    // show global search form when "search" button is clicked
    const $dropdownSearch = $('#dropdown-search');
    $('.header-search-button').click(function onClick(e) {
        e.preventDefault();
        $(this).toggleClass('dropdown-visible');
        $dropdownSearch.toggleClass('visuallyhidden');
    });

    // hide search form when clicked away from
    $(document).on('click', () => {
        $dropdownSearch.addClass('visuallyhidden');
    });

    // clear search input
    $('.js-clear-search').on('click', function onClick(e) {
        e.preventDefault();
        $(this).closest('form.search-form').find('.search-field').val('');
    });

    // add x to clear search when user types in
    $('#global-search').keypress(() => {
        $('#clear-search').removeClass('visuallyhidden');
    });

    // set focus to text input on search click
    $('#search-global').on('click', function onclick() {
        $('input', this).focus();
        return false;
    });

    // submit search form when click on search icon
    $('.js-search-submit').on('click', function onclick() {
        $(this).closest('form').submit();
    });

    // Put Arabic text in Read More link for Arabic language search results
    if (window.CLOROX_GLOBAL.language === 'ar' && $('.read-more').length > 0) {
        $('.read-more', $('.js-relevanssi')).text('اقرأ أكثر');
    }

    // mobile search
    const $iconsSearch = $('.header-wrapper .js-mobile-search-icon');
    const $searchIcon = $('#icon-search-open');
    const $searchCloseIcon = $('#icon-search-close');
    const $search = $('.js-mobile-search-menu');

    // Set up Mobile Menu Interactions
    function mobileNavInit() {
        // the icon switch-aroo
        const $icons = $('.header-wrapper .js-mobile-menu-icon');
        const $menuIcon = $('#icon-menu-open');
        const $menu = $menuIcon.parent();

        function openMenu() {
            $icons.toggleClass('active');
            $menu.height('100%').addClass('open');
            $menuIcon.attr('aria-expanded', 'true');
            $('.nav-primary-mobile').show();
            $('.nav-secondary-mobile').hide();
            $('.nav-tertiary-mobile').hide();
        }

        function closeMenu() {
            $icons.toggleClass('active');
            $menu.height('initial').removeClass('open');
            $menuIcon.attr('aria-expanded', 'false');
        }

        function mobileNavToggle() {
            if (!$menu.hasClass('open')) {
                openMenu();
            } else {
                closeMenu();
            }
        }

        $icons.on('click', () => {
            if ($search.hasClass('open')) {
                $('#icon-search-close').click();
            }

            mobileNavToggle();
        });

        // open menu by pressing return
        $icons.keydown((event) => {
            if (event.keyCode === 13) {
                mobileNavToggle();
            }
        });

        // close mobile nav by pressing escape
        $(document).keyup((event) => {
            if (event.keyCode === 27 && $('#icon-menu-close').hasClass('active')) {
                closeMenu();
            }
        });

        // mobile menu top level dropdown
        const $dropdown = $('.nav-primary-mobile').closest('.dropdown');

        // open submenu
        $('.nav-primary-mobile .js-nav-mobile-submenu').on('click', function onclick() {
            const id = $(this).data('id');
            $('.nav-primary-mobile').hide();
            $(`.js-nav-secondary-mobile-${id}`).show();
            $dropdown.addClass('secondary-active');
            return false;
        });
        $('.nav-secondary-mobile .js-nav-mobile-submenu').on('click', function onclick() {
            const id = $(this).data('id');
            $('.nav-secondary-mobile').hide();
            $(`.js-nav-tertiary-mobile-${id}`).show();
            return false;
        });

        // go back submenus
        $('.nav-secondary-mobile .back-button').on('click', () => {
            $('.nav-secondary-mobile').hide();
            $('.nav-primary-mobile').show();
            $dropdown.removeClass('secondary-active');
        });
        $('.nav-tertiary-mobile .back-button').on('click', function onclick() {
            const id = $(this).data('id');
            $(`.js-nav-secondary-mobile-${id}`).show();
            $('.nav-tertiary-mobile').hide();
        });

        // some mobile nav items don't have links, so should just open submenu
        $('.js-nav-mobile-no-link').on('click', function onclick(e) {
            const href = this.getAttribute('href');
            // link could be '#', so any too short should be handled
            if (!href || href.length < 3) {
                e.preventDefault();
                $('.js-nav-mobile-submenu', this).click();
                return false;
            }
            return null;
        });

        $iconsSearch.on('click', () => {
            if ($menu.hasClass('open')) {
                closeMenu();
            }

            if (!$search.hasClass('open')) {
                $iconsSearch.toggleClass('active');
                $search.height('100%').addClass('open');
                $searchIcon.attr('aria-expanded', 'true');
                $searchCloseIcon.attr('aria-hidden', 'false');
            } else {
                $iconsSearch.toggleClass('active');
                $search.height('initial').removeClass('open');
                $searchIcon.attr('aria-expanded', 'false');
                $searchCloseIcon.attr('aria-hidden', 'true');
            }
        });
    }

    mobileNavInit();

    $('#stickyheader').sticky({ topSpacing: 0 });

    // keyboard controls for menus
    // handle down arrow & esc to open/close submenus
    const $topNavItems = $('.primary-nav-item.nav-desktop-item').on('keydown', function onkeydown(e) {
        const $this = $(this);
        if (e.keyCode === 40) {
            // down arrow
            $this.addClass('open');
            $('.dropdown', $this).attr('aria-hidden', false);
        }
        if (e.keyCode === 27) {
            // esc
            $this.removeClass('open');
            $('.dropdown', $this).attr('aria-hidden', true);
            $this.find('a').focus();
        }
    });

    // close submenu when focus moves to item not in submenu
    $(document).on('focusin', (e) => {
        const $openMenu = $topNavItems.filter('.open');
        if (!$(e.target).closest($openMenu).length) {
            $openMenu.removeClass('open');
            $('.dropdown', $openMenu).attr('aria-hidden', true);
        }
    });

    // close submenu on click or focus outside of menu item
    $(document).on('click', () => {
        $topNavItems.removeClass('open');
        $('.dropdown', $topNavItems).attr('aria-hidden', true);
    });

    // aria-hidden handling for main nav menu
    $('.nav-desktop-item')
        .on('mouseenter', function onmouseenter() {
            $('.dropdown', this).attr('aria-hidden', false);
        })
        .on('mouseleave', function onclick() {
            $('.dropdown', this).attr('aria-hidden', true);
        });

    // determine current page
    if ($('body#products, body.single-product, body.tax-product_category').length) {
        $('.nav-primary-items li.nav-menu-products').addClass('js-current-menu-item');
    } else if ($('body#how-to, body.single-how-to, body.tax-howto_category').length) {
        $('.nav-primary-items li.nav-menu-howto').addClass('js-current-menu-item');
    } else if (
        $(
            'body#why-clean-matters, body#our-causes, body#safe-water-project, body#environmental-commitment, body#the-truth-about-bleach, body#classroom-resources, body#our-purpose'
        ).length
    ) {
        $('.nav-primary-items li.nav-menu-clean').addClass('js-current-menu-item');
    } else if ($('body.search').length) {
        $('.nav-primary-items li.nav-menu-subtemplate-search').addClass('js-current-menu-item');
    } else {
        $('.nav-primary-items li:last').addClass('js-current-menu-item');
    }

    const marker = $('#marker');
    const current = $('.js-current-menu-item');

    // Initialize the marker position and the active class
    current.addClass('js-desktop-active');
    marker.css({
        // Place the marker in the middle of the border
        bottom: -(marker.height() / 2),
        left: current.position().left,
        width: current.outerWidth(),
        display: 'block',
    });

    $('.nav-primary-items li').mouseover(function mosueover() {
        const self = $(this);
        const offsetLeft = self.position().left;
        // Use the element under the pointer OR the current page item
        const width = self.outerWidth() || current.outerWidth();
        // Ternary operator, because if using OR when offsetLeft is 0, it is considered a falsy value, thus causing a bug for the first element.
        const left = offsetLeft === 0 ? 0 : offsetLeft || current.position().left;

        // Play with the active class
        $('.js-desktop-active').removeClass('js-desktop-active');
        self.addClass('js-desktop-active');

        $('.js-desktop-hover').removeClass('js-desktop-hover');
        self.addClass('js-desktop-hover');

        marker.css({
            left,
            width,
        });
    });

    // When the mouse leaves the menu
    $('.nav-primary-items').mouseleave(() => {
        // remove all active classes, add active class to the current page item
        $('.js-desktop-active').removeClass('js-desktop-active');
        current.addClass('js-desktop-active');

        $('.js-desktop-hover').removeClass('js-desktop-hover');

        // reset the marker to the current page item position and width
        marker.css({
            left: current.position().left,
            width: current.outerWidth(),
        });
    });

    // recalculate on window resize
    $(window).on('resize', () => {
        marker.css({
            left: current.position().left,
            width: current.outerWidth(),
        });
    });
});
